module.exports = __webpack_public_path__ + "img/tajwid1.d8847c45.png";